module.exports = __webpack_public_path__ + "img/mesa_l001k.1df2f37e.png";